webpackJsonp([33451537186499],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerLanding = function BannerLanding(props) {
	
	    var background = props.background;
	
	    return _react2.default.createElement("section", { id: "banner", className: "style", style: { backgroundImage: "url(" + background + ")" } });
	};
	
	exports.default = BannerLanding;
	module.exports = exports["default"];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(201);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _digitalRealities = __webpack_require__(19);
	
	var _digitalRealities2 = _interopRequireDefault(_digitalRealities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//
	// import hero from '../assets/images/banner_brand-design.jpg'
	// import processDiscover from '../assets/images/process-discover.jpg'
	// import processDefine from '../assets/images/process-define.jpg'
	// import processDesign from '../assets/images/process-design.jpg'
	// import processBuild from '../assets/images/process-build.jpg'
	var DigitalRealities = function (_React$Component) {
	    _inherits(DigitalRealities, _React$Component);
	
	    function DigitalRealities() {
	        _classCallCheck(this, DigitalRealities);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    DigitalRealities.prototype.render = function render() {
	        var _this2 = this;
	
	        var projects = _digitalRealities2.default.map(function (project, idx) {
	            return _react2.default.createElement(
	                'article',
	                { key: 'project-' + project.name, id: project.id, onClick: _this2.props.handleClick.bind(_this2, idx) },
	                _react2.default.createElement(_gatsbyLink2.default, { to: project.url, className: 'link primary' }),
	                _react2.default.createElement('img', { src: project.img })
	            );
	        });
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'IMBIBE - Brand Design'
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: 'Brand Design Landing Page' }),
	                _react2.default.createElement('link', { href: '//cloud.webtype.com/css/205c6ee8-8be6-4e77-9137-0a8616dac421.css', rel: 'stylesheet', type: 'text/css' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'main' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'one', className: 'tiles' },
	                    projects
	                )
	            )
	        );
	    };
	
	    return DigitalRealities;
	}(_react2.default.Component);
	
	exports.default = DigitalRealities;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-digital-realities-js-75a8cc4d24df9fa033fb.js